<template>
  <v-container fluid>
    <v-dialog
      scrollable
      persistent
      v-model="dialogs.addToPlan"
      max-width="1000"
    >
      <material-card
        v-if="
          planInsuranceCarrier !== null && planInsuranceCarrier !== undefined
        "
        :title="
          $t(
            'components.plancreationwizard.add_insurance_carrier_to_plan_{0}',
            [trans(planInsuranceCarrier.InsuranceCarrier, 'Name')]
          )
        "
        icon="edit"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-dialog v-model="dialogs.cancel" persistent max-width="400">
            <v-card>
              <v-card-title class="headline">
                {{ $t("views.employers_view.cancel_wizard") }}
              </v-card-title>
              <v-card-text>
                {{
                  $t(
                    "components.inmemoryemployers.if_you_exit_the_wizard_any_changes_made_so_far"
                  )
                }}
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="dialogs.cancel = false">
                  {{ $t("views.employers_view.keep_working") }}
                </v-btn>
                <v-btn color="primary" text @click="cancelWizard()">
                  {{ $t("views.employers_view.cancel_anyway") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-row>
            <v-stepper
              v-model="step"
              vertical
              class="elevation-0"
              style="width: 100%"
            >
              <v-stepper-step :complete="step > 1" step="1">
                {{
                  $t(
                    "components.addplaninsurancecarrier.insurance_carrier_info"
                  )
                }}
                <small>
                  {{ $t("components.inmemorystores.fill_in_the_fields") }}
                </small>
              </v-stepper-step>

              <v-stepper-content step="1">
                <div row justify-center>
                  <v-form
                    ref="policyForm"
                    v-model="valid.policy"
                    v-if="planInsuranceCarrier.Policy"
                  >
                    <v-container fluid grid-list-md>
                      <v-row>
                        <v-col xs="12" sm="6" md="4">
                          <no-autocomplete-textfield
                            v-model="planInsuranceCarrier.Policy.Number"
                            :label="$t('globals.policy_number')"
                            :rules="[
                              $rules.required,
                              (str) => {
                                if (selected) {
                                  if (selected.Identifier) {
                                    return (
                                      internalPlanInsuranceCarriers
                                        .filter(
                                          (c) =>
                                            c.Identifier != selected.Identifier
                                        )
                                        .filter((c) => c.Policy.Number == str)
                                        .length === 0 ||
                                      $t(
                                        'views.insurancecarriers.policy_number_must_be_unique'
                                      )
                                    );
                                  }
                                }
                                return (
                                  internalPlanInsuranceCarriers.filter(
                                    (c) => c.Policy.Number == str
                                  ).length === 0 ||
                                  $t(
                                    'views.insurancecarriers.policy_number_must_be_unique'
                                  )
                                );
                              },
                            ]"
                            class="required"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="3">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-container pa-0>
                                <v-row no-gutters>
                                  <v-col>
                                    <image-uploader-string
                                      @image-data="updateLogo($event)"
                                      :image="planInsuranceCarrier.LogoBase64"
                                      :label="
                                        $t(
                                          'globals.logo'
                                        )
                                      "
                                    ></image-uploader-string>
                                  </v-col>
                                  <v-col
                                    style="margin-top: 20px; margin-left: 3px"
                                    cols="auto"
                                  >
                                    <v-icon v-bind="attrs" v-on="on">
                                      help
                                    </v-icon>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </template>
                            <span>
                              {{
                                $t(
                                  "components.plancreationwizard.trust_fund_logo_tooltip"
                                )
                              }}
                            </span>
                          </v-tooltip>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="3">
                          <v-checkbox
                            v-if="hasBeneficiaries"
                            :label="
                              $t(
                                'views.insurancecarriers.allow_bebeficiaries_statement'
                              )
                            "
                            v-model="
                              planInsuranceCarrier.Policy.HasBeneficiaries
                            "
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </div>
                <v-btn
                  color="primary"
                  @click="step = 2"
                  :disabled="!valid.policy"
                >
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-stepper-content>

              <v-stepper-step :complete="step > 2" step="2">
                {{
                  $t(
                    "components.addplaninsurancecarrier.insurance_carrier_contact_details"
                  )
                }}
                <small>
                  {{ $t("components.inmemorystores.fill_in_the_fields") }}
                </small>
              </v-stepper-step>

              <v-stepper-content step="2">
                <div row justify-center>
                  <v-form
                    ref="planInsuranceCarrierForm"
                    v-model="valid.planInsuranceCarrier"
                  >
                    <v-container fluid grid-list-md>
                      <v-row>
                        <v-col xs="12" sm="6" md="4">
                          <no-autocomplete-textfield
                            v-model="planInsuranceCarrier.PhoneNumber"
                            :label="$t('globals.telephone')"
                            :rules="[$rules.phone]"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col xs="12" sm="6" md="4">
                          <no-autocomplete-textfield
                            v-model="planInsuranceCarrier.Fax"
                            :label="$t('globals.fax_number')"
                            :rules="[$rules.phone]"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col xs="12" sm="6" md="4">
                          <no-autocomplete-textfield
                            v-model="planInsuranceCarrier.Email"
                            :label="$t('headers.contacts.email')"
                            :rules="[$rules.email]"
                          ></no-autocomplete-textfield>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </div>
                <v-btn text @click="step = 1">
                  {{ $t("globals.back") }}
                </v-btn>
                <v-btn
                  color="primary"
                  @click="continueToAddress()"
                  :disabled="!valid.planInsuranceCarrier"
                >
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-stepper-content>

              <v-stepper-step :complete="step > 3" step="3">
                {{
                  $t(
                    "components.addplaninsurancecarrier.insurance_carrier_address"
                  )
                }}
                <small>
                  {{
                    $t(
                      "components.addplaninsurancecarrier.add_address_to_this_insurance_carrier"
                    )
                  }}
                </small>
              </v-stepper-step>
              <v-stepper-content step="3">
                <v-container>
                  <!-- <address-form
                    ref="address"
                    :provinces="options.Models.Province"
                    :item="planInsuranceCarrier"
                  ></address-form> -->
                  <canada-post-address
                    :address="planInsuranceCarrier.Address"
                    @update-address="planInsuranceCarrier.Address = $event"
                    @valid="valid.address=$event"
                  />
                </v-container>
                <v-btn text @click="addressBack()">
                  {{ $t("globals.back") }}
                </v-btn>
                <v-btn
                :disabled="!valid.address"
                  color="primary"
                  @click="step = 4"
                >
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-stepper-content>

              <v-stepper-step :complete="step > 4" :step="4">
                {{ $t("globals.manage_contacts") }}
                <small>
                  {{
                    $t(
                      "components.addplaninsurancecarrier.add_or_edit_contacts_for_this_insurance_carrier"
                    )
                  }}
                </small>
              </v-stepper-step>

              <v-stepper-content :step="4">
                <contacts
                  @contacts-changed="planInsuranceCarrier.Contacts = $event"
                  :contacts="planInsuranceCarrier.Contacts"
                  identifier="planInsuranceCarrierContacts"
                  :planIdentityId="planIdentityId"
                ></contacts>
                <v-btn text @click="step = 3">
                  {{ $t("globals.back") }}
                </v-btn>
              </v-stepper-content>
            </v-stepper>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closePlanInsuranceCarrier()">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!planInsuranceCarrierValid()"
            color="primary"
            @click="addToPlan()"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="dialogs.deletePlanInsuranceCarrier"
      scrollable
      persistent
      max-width="400"
    >
      <material-card
        :title="
          $t('components.plancreationwizard.remove_insurance_carrier_from_plan')
        "
        :color="$vuetify.theme.themes.light.error"
        icon="remove"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color text @click="dialogs.deletePlanInsuranceCarrier = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" text @click="removePlanInsuranceCarrier">
            {{ $t("globals.remove") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.addInsuranceCarrier"
      persistent
      max-width="500px"
    >
      <material-card
        v-if="insuranceCarrier !== null && insuranceCarrier !== undefined"
        :title="$t('components.plancreationwizard.add_insurance_carrier')"
        icon="add"
        :color="$vuetify.theme.themes.light.success"
      >
        <v-card-text>
          <v-form ref="insuranceCarrierForm" v-model="valid.insuranceCarrier">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col xs="12">
                  <trans-textbox
                    v-model="insuranceCarrier"
                    :label="$t('globals.name')"
                    :rules="[$rules.required, rules.uniqueName]"
                    field="Name"
                    class="required"
                  ></trans-textbox>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeInsuranceCarrier()">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.insuranceCarrier"
            color="primary"
            @click="tryAddInsuranceCarrier()"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <material-card
:title="$t('globals.insurance_carriers')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="home_work"
    >
      <v-container>
        <v-row>
          <v-col>
            <v-btn
              style="margin-left: 5px"
              color="success"
              dark
              @click="
                insuranceCarrier = {};
                dialogs.addInsuranceCarrier = true;
              "
              :disabled="disabled"
            >
              <v-icon>add</v-icon>
              {{ $t("globals.add_new") }}
            </v-btn>
          </v-col>
          <v-col v-if="selected !== null && selected !== undefined">
            <v-btn
              style="margin-left: 25px"
              color="primary"
              dark
              @click="
                planInsuranceCarrier = JSON.parse(JSON.stringify(selected));
                step = 1;
                dialogs.addToPlan = true;
              "
              :disabled="disabled"
            >
              <v-icon>edit</v-icon>
              {{ $t("globals.edit") }}
            </v-btn>
          </v-col>
        </v-row>
        <DualListBoxSingleSelect
          :disabled="
            ((planEffectiveDate === null || planEffectiveDate === undefined) &&
              internalPlanInsuranceCarriers.length > 0) ||
              disabled
          "
          ref="insuranceCarriersListbox"
          :source="internalInsuranceCarriers"
          :destination="internalPlanInsuranceCarriers"
          label="Name"
          :displayFunc2="(item) => `${item.Name} (${item.Policy.Number})`"
          @selected="selected = $event"
          @add-destination="onAddInsuranceCarrier"
          @add-source="onRemoveInsuranceCarrier"
          :editable="
            planEffectiveDate !== null && planEffectiveDate !== undefined
          "
        />
      </v-container>
    </material-card>
  </v-container>
</template>

<script>
// import AddressForm from "@/components/AddressForm";
import { mapGetters } from "vuex";
import DualListBoxSingleSelect from "@/components/DualListboxSingleSelect";
import { translate2 } from "@/trans2";
import Contacts from "@/components/PlanBuilder/Contacts";
import TransTextbox from "@/components/TransTextbox";
import ImageUploaderString from "@/components/ImageUploaderString";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import CanadaPostAddress from "@/components/CanadaPostAddress";
export default {
  components: {
    DualListBoxSingleSelect,
    // AddressForm,
    Contacts,
    TransTextbox,
    ImageUploaderString,
    NoAutocompleteTextfield,
    CanadaPostAddress
  },
  directives: { mask },
  props: [
    "insuranceCarriers",
    "planInsuranceCarriers",
    "planIdentityId",
    "planEffectiveDate",
    "hasBeneficiaries",
    "disabled",
  ],
  data() {
    return {
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
        uniqueName: (v) => {
          return (
            !v ||
            this.internalInsuranceCarriers.filter((o) => o.Name === v)
              .length === 0 ||
            "Name must be unique"
          );
        },
      },
      telephoneMask: "(###) ### - ####",
      selected: null,
      step: 1,
      internalInsuranceCarriers: [],
      internalPlanInsuranceCarriers: [],
      insuranceCarrier: null,
      valid: {
        insuranceCarrier: true,
        planInsuranceCarrier: true,
        policy: true,
        address: true
      },
      dialogs: {
        addToPlan: false,
        deletePlanInsuranceCarrier: false,
        addInsuranceCarrier: false,
      },
      planInsuranceCarrier: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    planInsuranceCarriers: {
      handler(v) {
        // console.log("plan ic ", v);
        // if (
        //   this.planEffectiveDate !== null &&
        //   this.planEffectiveDate !== undefined
        // ) {
        this.internalPlanInsuranceCarriers = v;
        // }
        // else {
        //   this.internalPlanInsuranceCarriers = [];
        // }
        // this.$emit("valid", this.internalPlanInsuranceCarriers.length > 0);
      },
    },
    insuranceCarriers: {
      handler(v) {
        // console.log(JSON.stringify(v));
        this.internalInsuranceCarriers = v;
      },
    },
    internalPlanInsuranceCarriers: {
      handler(v) {
        // console.log("internal ic ", v);
        this.$emit("plan-insurance-carriers", v);
      },
    },
    hasBeneficiaries: {
      handler(v) {
        if (!v) {
          for (let ic of this.internalPlanInsuranceCarriers) {
            ic.Policy.HasBeneficiaries = false;
          }
        }
      },
    },
  },
  mounted() {
    // console.log("ic mounted!!!!!", this.planEffectiveDate)
    // if (
    //   this.planEffectiveDate !== null &&
    //   this.planEffectiveDate !== undefined
    // ) {
    this.internalPlanInsuranceCarriers = this.planInsuranceCarriers;
    this.internalInsuranceCarriers = this.insuranceCarriers;
    // }
    // else {
    //   // this.internalPlanInsuranceCarriers = [];
    //   this.$emit("plan-insurance-carriers", []);
    // }
    // this.$emit("valid", this.internalPlanInsuranceCarriers.length > 0);
  },
  methods: {
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    continueToAddress() {
      if (this.$refs.address) {
        this.$refs.address.validate();
      }
      this.step = 3;
    },
    addressBack() {
      if (this.$refs.address) {
        this.$refs.address.resetValidation();
      }
      this.step = 2;
    },
    updateLogo(image) {
      this.planInsuranceCarrier.LogoBase64 = image;
      this.$forceUpdate();
    },
    init() {
      if (
        this.planEffectiveDate !== null &&
        this.planEffectiveDate !== undefined
      ) {
        this.internalPlanInsuranceCarriers = this.planInsuranceCarriers;
      } else {
        this.internalPlanInsuranceCarriers = [];
      }
      this.internalInsuranceCarriers = this.insuranceCarriers;
      // this.$emit("valid", this.internalInsuranceCarriers.length > 0);
    },
    trans(item, field) {
      return translate2(item, field);
    },
    planInsuranceCarrierValid() {
      if (!this.planInsuranceCarrier) return false;
      return (
        this.valid.planInsuranceCarrier &&
        this.valid.policy && this.valid.address
      );
    },
    onAddInsuranceCarrier: async function({ selected }) {
      let newInsuranceCarrier = selected[0];
      this.planInsuranceCarrier = {
        Name:
          newInsuranceCarrier.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          ).length > 0
            ? newInsuranceCarrier.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name
            : newInsuranceCarrier.Name,
        InsuranceCarrier: JSON.parse(JSON.stringify(newInsuranceCarrier)),
        Policy: {},
        Contacts: [],
        Identifier: Math.random().toString(),
      };
      this.step = 1;
      this.dialogs.addToPlan = true;
    },
    onRemoveInsuranceCarrier: async function({ selected }) {
      this.planInsuranceCarrier = JSON.parse(JSON.stringify(selected[0]));
      this.dialogs.deletePlanInsuranceCarrier = true;
    },
    removePlanInsuranceCarrier() {
      this.internalPlanInsuranceCarriers = this.internalPlanInsuranceCarriers.filter(
        (p) => p.Identifier != this.planInsuranceCarrier.Identifier
      );
      this.$emit(
        "insurance-carriers",
        this.internalInsuranceCarriers.sort(function(a, b) {
          return a.Name < b.Name;
        })
      );
      this.closePlanInsuranceCarrier();
    },
    closeInsuranceCarrier() {
      this.insuranceCarrier = null;
      if (this.$refs.insuranceCarrierForm)
        this.$refs.insuranceCarrierForm.resetValidation();
      this.dialogs.addInsuranceCarrier = false;
    },
    async tryAddInsuranceCarrier() {
      let item = JSON.parse(JSON.stringify(this.insuranceCarrier));
      if (!item.Name) {
        item.Name = item.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Name;
      }
      this.internalInsuranceCarriers.push(item);
      this.closeInsuranceCarrier();
    },
    closePlanInsuranceCarrier() {
      this.planInsuranceCarrier = null;
      if (this.$refs.planInsuranceCarrierForm)
        this.$refs.planInsuranceCarrierForm.resetValidation();
      this.dialogs.addToPlan = false;
      this.dialogs.deletePlanInsuranceCarrier = false;
      // this.$emit("valid", this.internalPlanInsuranceCarriers.length > 0);
    },
    addToPlan() {
      // if(this.planInsuranceCarrier.Id == null && this.planInsuranceCarrier.Identifier == null){
      //   this.planInsuranceCarrier.Identifier = Math.random().toString();
      // } else {
      // if(this.planInsuranceCarrier.Identifier != null){
      this.internalPlanInsuranceCarriers = this.internalPlanInsuranceCarriers.filter(
        (i) => i.Identifier !== this.planInsuranceCarrier.Identifier
      );
      // } else {
      //   this.internalPlanInsuranceCarriers = this.internalPlanInsuranceCarriers.filter(i=>i.Id !== this.planInsuranceCarrier.Id)
      // }
      // }
      let item = JSON.parse(JSON.stringify(this.planInsuranceCarrier));

      if (this.planEffectiveDate) {
        item.Policy.EffectiveDate = this.planEffectiveDate;
      }
      this.internalPlanInsuranceCarriers.push(item);
      this.closePlanInsuranceCarrier();
    },
  },
};
</script>

<style></style>
